import { Card, CardContent } from "@/components/ui/card"
import { SPACING } from "@/constants/layout"
import { COMPANY_CONTACT } from "@/constants/contact"

const privacyContent = [
  {
    title: "Information Collection",
    content: [
      "Personal information (name, email, contact details) when you register or contact us",
      "Usage data and analytics when you browse our website",
      "Financial information when you make transactions",
      "Communication records when you interact with our support team"
    ]
  },
  {
    title: "How We Use Your Information",
    content: [
      "To provide and maintain our services",
      "To notify you about changes to our services",
      "To provide customer support",
      "To gather analysis or valuable information to improve our services",
      "To detect, prevent and address technical issues"
    ]
  },
  {
    title: "Data Protection",
    content: [
      "We implement robust security measures to protect your data",
      "Regular security assessments and updates",
      "Limited access to personal information by authorized personnel",
      "Encryption of sensitive data in transit and at rest"
    ]
  },
  {
    title: "Cookie Policy",
    content: [
      "Essential cookies for website functionality",
      "Analytics cookies to understand user behavior",
      "Preference cookies to remember your settings",
      "You can control cookie settings through your browser"
    ]
  },
  {
    title: "Your Rights",
    content: [
      "Right to access your personal data",
      "Right to correct inaccurate data",
      "Right to request deletion of your data",
      "Right to restrict processing of your data",
      "Right to data portability"
    ]
  }
]

export function PrivacyPage() {
  return (
    <div className={SPACING.page}>
      {/* Hero Section */}
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-4xl font-bold tracking-tight mb-6">
            Privacy Policy
          </h1>
          <p className="text-lg text-neutral-600 dark:text-neutral-400">
            We are committed to protecting your privacy and ensuring the security of your personal information.
          </p>
          <p className="text-sm text-neutral-600 dark:text-neutral-400 mt-4">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>

      {/* Content Sections */}
      <div className="container mx-auto px-4">
        <div className={`max-w-4xl mx-auto ${SPACING.content}`}>
          {privacyContent.map((section) => (
            <Card key={section.title} variant="default" size="default">
              <CardContent className="p-6">
                <h2 className="text-2xl font-semibold mb-4">{section.title}</h2>
                <ul className="space-y-3">
                  {section.content.map((item) => (
                    <li 
                      key={item} 
                      className="text-neutral-600 dark:text-neutral-400 flex items-start"
                    >
                      <span className="mr-2">•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}

          <Card variant="default" size="default">
            <CardContent className="p-6">
              <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
              <p className="text-neutral-600 dark:text-neutral-400">
                If you have any questions about this Privacy Policy, please contact us at:
              </p>
              <div className="mt-4">
                <p className="text-neutral-600 dark:text-neutral-400">
                  Email: {COMPANY_CONTACT.departments.privacy}
                </p>
                <p className="text-neutral-600 dark:text-neutral-400">
                  Address: {COMPANY_CONTACT.main.address}
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  )
} 